<template lang="pug">
    v-dialog(v-model="dialog" v-if="dialog" fullscreen hide-overlay transition="dialog-bottom-transition")
        template
            v-snackbar(
                v-model="snackbar"
                :timeout="10000"
                color='error'
            ) {{ snackbarMessage }}
            v-toolbar(dark dense color="red" class="navFixed")
                v-toolbar-title i-Permit Preview    
                v-spacer
                v-toolbar-title(v-if="ip.ipStatus !== 10 && getApproveStatus(ip.ipWorkflow) == '7'") Approved on {{formatDate(getApproveDate(ip.ipWorkflow))}}
                v-toolbar-title(v-if="getApproveStatus(ip.ipWorkflow) == '8'") Rejected on {{formatDate(getApproveDate(ip.ipWorkflow))}}
                v-toolbar-items
                    v-btn(v-if="dialogType !== 'creator' && isCurrentApprover()" @click.stop="approvalDialog = true" color="red" depressed title='Approval' class="blink") 
                        v-icon(title="Approval") assignment_turned_in
                        | &nbsp; Approval
                    v-dialog(v-if="dialogType !== 'creator' && isCurrentApprover()" v-model="approvalDialog" persistent max-width="500px")
                        v-card()
                            v-card-title(class="headline grey lighten-2") Approval Form
                            v-card-text
                                v-layout(wrap)
                                    v-flex(xs12)
                                        v-radio-group(v-model="approval" row)
                                            v-radio(label="Approve" color="success" value="7")
                                            v-radio(v-if="ip.ipStatus !== 10" label="Reject" color="red" value="8")
                                            v-radio(v-if="ip.ipStatus == 10" label="Need Review" color="yellow darken-4" value="11")
                                            v-radio(v-else label="Need Review" color="yellow darken-4" value="3")
                                    v-flex(xs12)
                                        v-textarea(
                                            v-model="comment"
                                            filled
                                            label="Comment (Optional)"
                                            value=""
                                        )
                            v-card-actions
                                v-spacer
                                v-btn(text @click.native="approvalDialog = false") Close
                                v-btn(:disabled="!approval" text :loading="approvalDialog2" color="blue darken-1" @click="approvalDialog2 = true") Submit
                                v-dialog(
                                    v-model="approvalDialog2"
                                    hide-overlay
                                    persistent
                                    width="300")
                                    v-card(color="primary" dark)
                                    v-card-text Processing. Please wait!
                                        v-progress-linear(indeterminate color="white" class="mb-0")
                    v-btn(v-if="this.ip.ipStatus == 4 || this.ip.ipStatus == 8" @click="shareIP();" color="red" depressed title="Share" )
                        v-icon share
                        | &nbsp; Share
                        v-dialog(v-model="share" persistent max-width="400px")
                            v-card
                                v-card-title(class="headline grey lighten-3") Share
                                v-flex(class="headline grey lighten-3")
                                    v-row(no-gutters align="center" justify="center")
                                        ShareNetwork(
                                            v-for="network in networks"
                                            :key="network.key"
                                            class="ma-3 pa-3 green"
                                            :network="network.network"
                                            style="border-radius: 10px; box-shadow: -2px 4px #888888;"
                                            :url="shortenUrl"
                                            :title="sharing.title"
                                            :description="sharing.description"
                                        ) 
                                            i(:class="network.icon" style="color:white")
                                            span(class="ma-3" style="color:white") {{ network.name }}
                                v-spacer
                                v-flex(class="text-end headline grey lighten-2")
                                    v-btn(color="blue darken-1" text @click.native="share = false") Close
                    v-btn(@click="ip.ipStatus == 4 || ip.ipStatus == 8 ? print = true : printIP(ip._id)" color="red" depressed title="Print" )
                        v-icon print
                        | &nbsp; Print
                        v-dialog(v-model="print" persistent max-width="400px")
                            v-card
                                v-card-title(class="headline grey lighten-3") Print Document
                                v-alert(:value='true' color="success")
                                    h3(style="text-align: center; font-weight:normal; color: white;") To save the trees, please think to share it rather than print.
                                v-flex(class="headline grey lighten-3")
                                    v-row(no-gutters align="center" justify="center")
                                        v-btn(@click="printIP(ip._id); print = false;" class="ma-3 pa-3 red darken-2" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
                                            i(class="far fah fa-lg fa fa-print" style="color:white")
                                            span(class="ma-3" style="color:white") Print
                                        v-btn(@click="print = false; shareIP();" class="ma-3 pa-3 green" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
                                            i(class="far fah fa-lg fa fa-share-alt" style="color:white")
                                            span(class="ma-3" style="color:white") Share
                                v-spacer
                                v-flex(class="text-end headline grey lighten-2")
                                    v-btn(color="blue darken-1" text @click.native="print = false") Close
                    v-btn(@click.native="dialog = false" color="red" depressed)
                        v-icon(title="Close") cancel
                        | &nbsp; Close
            v-list(class="print-bg padTop60")
                div(:id="ip._id")
                    .page(size="Auto")
                        div(class="view-width" style="font-size:10px;")
                            table(class="view-width tableInput" style="margin-top:10px;")
                                tbody
                                    tr
                                        td( class="align-center" width="150" rowspan="3")
                                            img(class="verMiddle" src="../assets/BORNEO-INDOBARA.jpg" width="120px")
                                        td(class="align-center") SINARMAS MINING SYSTEM
                                        td( class="align-center" width="150" rowspan="3") 
                                            img(class="verMiddle" :src="`${API_URL}/qr/generate/?ipNo=${ip.ipNo}&formCode=${ip.ipForm}`" style="width:80px;margin:2px 0;")
                                    tr
                                        td(class="align-center") FORMULIR
                                    tr
                                        td(class="align-center") {{ formName[ip.ipForm] }}
                            
                            table( class="view-width tableInput" style="margin-top:10px;")
                                tbody
                                    tr
                                        td(class=" headerTable" width="150") SEKSI A: APLIKASI  
                                    tr
                                        td Sebagai panduan dalam memastikan pekerjaan menggunakan zat/bahan radioaktif telah dikendalikan dari bahaya-bahaya yang ada sebelum dilaksanakan.
                                    
                            table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                thead
                                    tr
                                        td(class="headerTable" width="150" colspan="7") SEKSI B: DETAIL IZIN
                                tbody(style="border: 1px solid black")
                                    
                                    tr
                                        td(width="150" class="headerTable") Tanggal
                                        td(width="250") {{ formatDate(ip.ipPelaksanaanStart) }} - {{ formatDate(ip.ipPelaksanaanEnd) }}
                                        td(class="headerTable") Nomor Izin Kerja
                                        td {{ip.ipNo}}  
                                    tr
                                        td(class="headerTable") Kontraktor / Subkontraktor
                                        td {{ ip.ipPerusahaan }}
                                        td(width="100" class="headerTable") Jam Berlaku Izin
                                        td() {{ip.ipJamBerlakuIzin}}                                        
                                    tr
                                        td(class="headerTable") Nama Pemegang Izin
                                        td {{ip.ipPemegangIzin.name}}
                                        td(width="100" class="headerTable") Jam Berakhir Izin
                                        td() {{ip.ipJamBerakhirIzin}}
                                    tr
                                        td(width="100" class="headerTable") Lokasi Kerja
                                        td() {{ locations.join(', ') }}
                                        td(width="100" class="headerTable") Detail Lokasi
                                        td() {{ip.ipDetailLokasi}}
                            
                            table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                tbody
                                    tr
                                        td(class=" headerTable" width="150") SEKSI C: DETAIL PEKERJAAN  
                                    tr
                                        td(class=" headerTable" width="150") URAIAN PEKERJAAN:
                                    tr
                                        td
                                            div(v-html="ip.ipDetailPekerjaan" class="ck-content")

                            table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                tbody
                                    tr
                                        td(class=" headerTable" width="150" colspan="8") SEKSI D:  PENCEGAHAN / PERSYARATAN KHUSUS
                                    tr
                                        td(width="150" colspan="8") Berikan tanda check pada kolom di bawah Ya (Y) / Tidak (T) / Tidak Perlu (TP)
                                    tr
                                        td(class="align-center headerTable" width="20") Y
                                        td(class="align-center headerTable" width="20") T
                                        td(class="align-center headerTable" width="20") TP
                                        td(class="align-center headerTable" width="50") Daftar Periksa
                                        td(class="align-center headerTable" width="20") Y
                                        td(class="align-center headerTable" width="20") T
                                        td(class="align-center headerTable" width="20") TP
                                        td(class="align-center headerTable" width="50") Daftar Periksa
                                    tr
                                        td(class="align-center")
                                            img(v-if="ip.ipProsedurKerja == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        td(class="align-center")
                                            img(v-if="ip.ipProsedurKerja == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        td(class="align-center")
                                            img(v-if="ip.ipProsedurKerja == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        td Ada prosedur kerja (PPO, IK, AKA)?
                                        td(class="align-center")
                                            img(v-if="ip.ipAPD == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        td(class="align-center")
                                            img(v-if="ip.ipAPD == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        td(class="align-center")
                                            img(v-if="ip.ipAPD == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        td Alat Pelindung Diri tersedia?
                                    tr
                                        td(class="align-center")
                                            img(v-if="ip.ipSosialisasiProsedur == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        td(class="align-center")
                                            img(v-if="ip.ipSosialisasiProsedur == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        td(class="align-center")
                                            img(v-if="ip.ipSosialisasiProsedur == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        td Prosedur sudah disosialisasikan?
                                        td(class="align-center")
                                            img(v-if="ip.ipAPDKhusus == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        td(class="align-center")
                                            img(v-if="ip.ipAPDKhusus == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        td(class="align-center")
                                            img(v-if="ip.ipAPDKhusus == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        td Ada alat pelindung diri khusus?
                                    tr
                                        td(class="align-center")
                                            img(v-if="ip.ipKompetenKTT == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        td(class="align-center")
                                            img(v-if="ip.ipKompetenKTT == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        td(class="align-center")
                                            img(v-if="ip.ipKompetenKTT == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        td Pekerja kompeten / ada penunjukan KTT?
                                        td(class="align-center")
                                            img(v-if="ip.ipInspeksiPeralatan == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        td(class="align-center")
                                            img(v-if="ip.ipInspeksiPeralatan == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        td(class="align-center")
                                            img(v-if="ip.ipInspeksiPeralatan == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        td Hasil inspeksi peralatan?
                                    tr
                                        td(class="align-center")
                                            img(v-if="ip.ipIzinBAPETEN == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        td(class="align-center")
                                            img(v-if="ip.ipIzinBAPETEN == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        td(class="align-center")
                                            img(v-if="ip.ipIzinBAPETEN == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        td Logger ada izin dari BAPETEN?
                                        td(class="align-center")
                                            img(v-if="ip.ipDosimeterTLD == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        td(class="align-center")
                                            img(v-if="ip.ipDosimeterTLD == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        td(class="align-center")
                                            img(v-if="ip.ipDosimeterTLD == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        td Ada Dosimeter / TLD? 

                            table(style="margin-top:10px;width:3cm;border: 1px solid black;" class="autoPageBreak")
                                tbody(v-if="ip.ipAttachmentFiles.docPendukung") 
                                    v-btn(tile text @click="download(ip.ipAttachmentFiles.docPendukung)" style="font-size:12px;letter-spacing:0px;margin:0px;padding:0;min-width:0;text-transform: none;font-family: 'Arial Narrow';font-weight:normal" height="auto") 
                                        tr
                                            td(style="padding-left:1px" ) 
                                                v-icon(small) mdi-attachment
                                            td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                                            td(style="background-color: rgb(204,204,204);padding-right:4px;padding-left:1px")
                                                img(src="../assets/check.png" width="10" )
                                tbody(v-else)
                                    tr
                                        td(style="padding-left:1px" ) 
                                            v-icon(small) mdi-attachment
                                        td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                                        td(style="background-color: rgb(204,204,204);padding-right:4px" )
                                            img(src="../assets/close.png" width="10" class="verMiddle")

                            table( class="view-width tableInput" style="margin-top:10px;")
                                tbody
                                    tr
                                        td(class=" headerTable" width="150") Tindakan Pencegahan Lainnya
                                    tr
                                        td
                                            div(v-html="ip.ipPencegahanLain" class="ck-content")

                            table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                tbody
                                    tr
                                        td(class="headerTable pl-2" colspan="5") SEKSI E: PENGESAHAN OLEH PEMBERI IZIN
                                    tr
                                        td(class="pl-2" colspan="5") Pastikan tingkat risiko sisa adalah rendah atau sudah dapat diterima  sebelum mengesahkan izin kerja khusus (lihat matrix risiko BIB).
                                    tr
                                        td(class="headerTable pl-2" colspan="5") Penanggung Jawab area
                                    tr
                                        td(class="" width="20%") Nama
                                        td(class="" width="20%") Jabatan
                                        td(class="" width="20%") Tanggal
                                        td(class="" width="20%" colspan="2") Tanda Tangan
                                    WorkflowDisplay(:workflow="ip.ipWorkflow[0]" :index="0" :form-type="ip.ipForm" :show-for="false")
                                    tr
                                        td(class="headerTable pl-2" colspan="5") Departemen HSE Kontraktor / Subkontraktor
                                    tr
                                        td(class="" width="20%") Nama
                                        td(class="" width="20%") Jabatan
                                        td(class="" width="20%") Tanggal
                                        td(class="" width="20%" colspan="2") Tanda Tangan
                                    WorkflowDisplay(:workflow="ip.ipWorkflow[1]" :index="1" :form-type="ip.ipForm" :show-for="false")
                                    tr
                                        td(class="headerTable align-center pl-2" colspan="2") OHS Dept. Head PT BIB
                                        td(class="headerTable align-center pl-2" colspan="3") KTT
                                    tr
                                        td(colspan="2")
                                            div(v-if="ip.ipWorkflow[2].leaveUser && ip.ipWorkflow[2].leaveUser.length > 0")
                                                div(v-if="ip.ipWorkflow[2].status == 7" class="approved")
                                                    img(src="../assets/check-64.png" style="width:25px;")
                                                    br
                                                    | {{ ip.ipWorkflow[2].leaveUser[0].name }}
                                                    br
                                                    | {{ ip.ipWorkflow[2].leaveUser[0].title }}
                                                    br
                                                    | {{ approvalTime(ip.ipWorkflow[2].date) }}
                                                div(v-else-if="ip.ipWorkflow[2].status == 8" class="approved")
                                                    img(src="../assets/close-64.png" style="width:25px;")
                                                    br
                                                    | {{ ip.ipWorkflow[2].admin_reject == true ? ip.ipWorkflow[2].admin_detail.name : ip.ipWorkflow[2].leaveUser[0].name }}
                                                    br
                                                    | {{ ip.ipWorkflow[2].admin_reject == true ? 'Admin' : ip.ipWorkflow[2].leaveUser[0].title }}
                                                    br
                                                    | {{ approvalTime(ip.ipWorkflow[2].date) }}
                                                div(v-else class="emptySign") {{ jabatanDetail(ip.ipWorkflow[2].postAs, 2, ip.ipForm) }}
                                            div(v-else)
                                                div(v-if="ip.ipWorkflow[2].status == 7" class="approved")
                                                    img(src="../assets/check-64.png" style="width:25px;")
                                                    br
                                                    | {{ ip.ipWorkflow[2].name }}
                                                    br
                                                    | {{ ip.ipWorkflow[2].title }}
                                                    br
                                                    | {{ approvalTime(ip.ipWorkflow[2].date) }}
                                                div(v-else-if="ip.ipWorkflow[2].status == 8" class="approved")
                                                    img(src="../assets/close-64.png" style="width:25px;")
                                                    br
                                                    | {{ ip.ipWorkflow[2].admin_reject == true ? ip.ipWorkflow[2].admin_detail.name : ip.ipWorkflow[2].name }}
                                                    br
                                                    | {{ ip.ipWorkflow[2].admin_reject == true ? 'Admin' : ip.ipWorkflow[2].title }}
                                                    br
                                                    | {{ approvalTime(ip.ipWorkflow[2].date) }}
                                                div(v-else class="emptySign") {{ jabatanDetail(ip.ipWorkflow[2].postAs, 2, ip.ipForm) }}

                                        td(colspan="3")
                                            div(v-if="ip.ipWorkflow[3].leaveUser && ip.ipWorkflow[3].leaveUser.length > 0")
                                                div(v-if="ip.ipWorkflow[3].status == 7" class="approved")
                                                    img(src="../assets/check-64.png" style="width:25px;")
                                                    br
                                                    | {{ ip.ipWorkflow[3].leaveUser[0].name }}
                                                    br
                                                    | {{ ip.ipWorkflow[3].leaveUser[0].title }}
                                                    br
                                                    | {{ approvalTime(ip.ipWorkflow[3].date) }}
                                                div(v-else-if="ip.ipWorkflow[3].status == 8" class="approved")
                                                    img(src="../assets/close-64.png" style="width:25px;")
                                                    br
                                                    | {{ ip.ipWorkflow[3].admin_reject == true ? ip.ipWorkflow[3].admin_detail.name : ip.ipWorkflow[3].leaveUser[0].name }}
                                                    br
                                                    | {{ ip.ipWorkflow[3].admin_reject == true ? 'Admin' : ip.ipWorkflow[3].leaveUser[0].title }}
                                                    br
                                                    | {{ approvalTime(ip.ipWorkflow[3].date) }}
                                                div(v-else class="emptySign") {{ jabatanDetail(ip.ipWorkflow[3].postAs, 3, ip.ipForm) }}
                                            div(v-else)
                                                div(v-if="ip.ipWorkflow[3] ? ip.ipWorkflow[3].status == 7 : false" class="approved")
                                                    img(src="../assets/check-64.png" style="width:25px;")
                                                    br
                                                    | {{ ip.ipWorkflow[3].name }}
                                                    br
                                                    | {{ ip.ipWorkflow[3].title }}
                                                    br
                                                    | {{ approvalTime(ip.ipWorkflow[3].date) }}
                                                div(v-else-if="ip.ipWorkflow[3] ? ip.ipWorkflow[3].status == 8 : false" class="approved")
                                                    img(src="../assets/close-64.png" style="width:25px;")
                                                    br
                                                    | {{ ip.ipWorkflow[3].admin_reject == true ? ip.ipWorkflow[3].admin_detail.name : ip.ipWorkflow[3].name }}
                                                    br
                                                    | {{ ip.ipWorkflow[3].admin_reject == true ? 'Admin' : ip.ipWorkflow[3].title }}
                                                    br
                                                    | {{ approvalTime(ip.ipWorkflow[3].date) }}
                                                div(v-else class="emptySign") {{ jabatanDetail(ip.ipWorkflow[3].postAs, 3, ip.ipForm) }}
                                    tr
                                        td(colspan="2")
                                            p(v-if="ip.ipWorkflow[2].comment || ''" class="align-left top-align comment") {{ ip.ipWorkflow[2].comment }}
                                            div(v-else class="emptySign")
                                        td(colspan="3")
                                            p(v-if="ip.ipWorkflow[3].comment || ''" class="align-left top-align comment") {{ ip.ipWorkflow[3].comment }}
                                            div(v-else class="emptySign")
                            table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                tbody
                                    tr
                                        td(class="headerTable pl-2" colspan="11") SEKSI F: PENYELESAIAN PEKERJAAN
                                    tr
                                        td(class="align-center headerTable" width="40") Y
                                        td(class="align-center headerTable" width="40") T
                                        td(class="align-center headerTable" width="40") TP
                                        td(class="headerTable") Daftar periksa
                                    td(class="align-center")
                                        img(v-if="false == 'Yes'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="false == 'No'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="false == 'Tidak Perlu'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Peralatan telah di kembalikan pada tempatnya? 
                                tr
                                    td(class="align-center")
                                        img(v-if="false == 'Yes'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="false == 'No'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="false == 'Tidak Perlu'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Sumber radiasi sudah dikembalikan ke bunker yang disediakan?
                                tr
                                    td(class="align-center")
                                        img(v-if="false == 'Yes'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="false == 'No'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="false == 'Tidak Perlu'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Area kerja sudah dirapikan kembali?
                                tr
                                    td(class="align-center")
                                        img(v-if="false == 'Yes'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="false == 'No'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="false == 'Tidak Perlu'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Log book keluar masuk sumber radiasi telah diisi? 
                            table(class="view-width tableInput" style="margin-top:0,1px;")
                                tbody
                                    tr
                                        td(class="headerTable pl-2" colspan="11") Pemegang izin
                                    tr
                                        td(class="align-center" width="33%") Nama
                                        td(class="align-center" width="33%") Tanggal
                                        td(class="align-center" width="34%") Tanda Tangan
                                    tr
                                        td
                                            div(v-if="ip.ipFinishedWorkflow[0] ? ip.ipFinishedWorkflow[0].status == 7 : false" class="approved")
                                                br
                                                | {{ ip.ipFinishedWorkflow[0].name }}
                                            div(v-else class="emptySign")
                                        td
                                            div(v-if="ip.ipFinishedWorkflow[0] ? ip.ipFinishedWorkflow[0].status == 7 : false" class="approved")
                                                br
                                                | {{approvalTime(ip.ipFinishedWorkflow[0].date)}}
                                            div(v-else class="emptySign")
                                        td
                                            div(v-if="ip.ipFinishedWorkflow[0] ? ip.ipFinishedWorkflow[0].status == 7 : false" class="approved")
                                                img(src="../assets/check-64.png" style="width:25px;")
                                            div(v-else class="emptySign")
                                    tr
                                        td(class="headerTable pl-2" colspan="3") Disetujui oleh:
                                    tr
                                        td(class="headerTable pl-2" colspan="3") OHS Dept. Head PT BIB
                                    tr
                                        td(class="align-center" width="33%") Nama
                                        td(class="align-center" width="33%") Tanggal
                                        td(class="align-center" width="34%") Tanda Tangan
                                    tr
                                        td
                                            div(v-if="ip.ipFinishedWorkflow[1] ? ip.ipFinishedWorkflow[1].status == 7 : false" class="approved")
                                                br
                                                | {{ ip.ipFinishedWorkflow[1].name }}
                                            div(v-else class="emptySign")
                                        td
                                            div(v-if="ip.ipFinishedWorkflow[1] ? ip.ipFinishedWorkflow[1].status == 7 : false" class="approved")
                                                br
                                                | {{approvalTime(ip.ipFinishedWorkflow[1].date)}}
                                            div(v-else class="emptySign")
                                        td
                                            div(v-if="ip.ipFinishedWorkflow[1] ? ip.ipFinishedWorkflow[1].status == 7 : false" class="approved")
                                                img(src="../assets/check-64.png" style="width:25px;")
                                            div(v-else class="emptySign")
</template>

<script>
import axios from 'axios';
import * as config from "../config/index.json";
import helper from "../helper/index.js";
import { mapState } from 'vuex';
import printJS from 'print-js';
import { handleGlobalErrorApproval } from '../helper/handleGlobalError.js';
import WorkflowDisplay from './WorkflowDisplay.vue';

export default {
  name: 'RadioaktifView',
  components: {
    WorkflowDisplay
  },
  props: {
    dialogType: String,
    ip: Object,
    approvalUser: Object
  },
  data: () => ({
    formName: config.FormName,
    dialog: false,
    regex: /\//gi,
    approvalDialog: false,
    approvalDialog2: false,
    comment: '',
    approval: null,
    share: false,
    print: false,
    snackbar: false,
    snackbarMessage: ''
  }),
  computed: {
    ...mapState(['API_URL', "networks", "sharing", "shortenUrl"]),
    locations(){
        let temp = []
        for (const index in this.ip.ipLocation) {
            temp.push(this.ip.ipLocation[index].name)
        }
        return temp
    },
  },
  methods: {
    jabatanDetail: helper.jabatanDetail,
    download(file) {
        this.$downloadFile(file);
    },
    shareIP() {
        this.$store.dispatch("getShortenUrl", {ip: this.ip, 
        approvalUser: this.approvalUser, context: this.share}).then(() => {
            this.share = true;
        });
    },
    printIP(id){
        printJS({
            printable: id, 
            type: 'html',
            scanStyles: false,
            css: ["/stylesheets/main.css" ,"/stylesheets/approval.css", "/stylesheets/vuetify.min.css", '/stylesheets/view.css', "/stylesheets/ck-content.css"]
        });
    },
    formatDate: helper.formatDateOnly,
    getApproveStatus(wf){
        let status = 0;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik){
                status=wf[i].status;
                break;
            }
        }
        return status;
    },
    getApproveDate(wf){
        let approvedWf = null;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik){
                approvedWf=wf[i];
                break;
            }
        }
        return approvedWf.date;
    },
    isCurrentApprover(){
        return helper.isApprover(
            this.$store.getters.isAuthenticated,
            this.ip,
            this.approvalUser
        );
    },
    approvalTime(date){
        return new Date(date).toLocaleString('en-GB');
    }
  },
  watch: {
    approvalDialog2 (val) {
        if (!val) return
        if(this.ip.ipStatus == 10){
            const NewFormData = {
                formId : this.ip._id,
                status : parseInt(this.approval),
                comment : this.comment,
                approvalUser : this.approvalUser
            }
            const config = {
                method: "post",
                url: `${this.API_URL}/v1/pengesahan/approval`,
                headers: {"Authorization": `Bearer ${this.$store.state.token}`},
                data: NewFormData
            };
            axios(config).then(res => {
                if (res.status == 200) {
                    setTimeout(() => {
                        this.dialog2 = false;
                        this.dialog = false;
                        location.reload();
                    },
                    1000);
                }
            }).catch(error => {
                handleGlobalErrorApproval(error, {
                    setSnackbarMessage: (msg) => { this.snackbarMessage = msg; },
                    showSnackbar: (show) => { this.snackbar = show; },
                    closeModals: () => { 
                        this.approvalDialog = false; 
                        this.approvalDialog2 = false; 
                    },
                    disableLoader: () => { 
                        this.$store.state.loader = false;
                    },
                });
            });
        }else{
            let formData = new FormData();
            formData.append('_id', this.ip._id);
            formData.append('status', parseInt(this.approval));
            formData.append('comment', this.comment);
            formData.append('approvalUser', JSON.stringify(this.approvalUser));
            formData.append('formCode', this.ip.ipForm);
            const sourceApproval = this.$route.query.sourceApproval || "";
            formData.append('sourceApproval', sourceApproval);
            const config = {
                method: "put",
                url: `${this.API_URL}/v1/requests/approval`,
                headers: {"Authorization": `Bearer ${this.$store.state.token}`},
                data: formData
            };
            axios(config).then(res => {
                if (res.status == 200) {
                    setTimeout(() => {
                        this.dialog2 = false;
                        this.dialog = false;
                        location.reload();
                    },
                    1000);
                }
            }).catch(error => {
                handleGlobalErrorApproval(error, {
                    setSnackbarMessage: (msg) => { this.snackbarMessage = msg; },
                    showSnackbar: (show) => { this.snackbar = show; },
                    closeModals: () => { 
                        this.approvalDialog = false; 
                        this.approvalDialog2 = false; 
                    },
                    disableLoader: () => { 
                        this.$store.state.loader = false;
                    },
                });
            });
        }
    }
    
  }
};
</script>
<style scoped>
.print-bg {
  background: rgb(204,204,204);
  padding-top: 10px;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:2px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  text-align: center;
  padding:5px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.align-left {
 align-items: left;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align:top;
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
    
}
table {
  border-collapse: collapse;
}
.headerTable{
    border: 1px solid black; 
    background-color: #cccccc;
}
.tableInput td{
    border: 1px solid black;
    padding-left: 5px;
}
.tableDetailIzin td{
    padding-left: 5px;
}
.verMiddle{
    vertical-align:middle;
}
.comment{
    word-break: break-all;
}
</style>